query GetEvents {
    events {
        id
        title
        slug
        image

        type
        location

        # Details
        description
        link

        start_date
        end_date
    }
}
